import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { aboutData } from '../data/mock';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8 }
    }
  };

  return (
    <section id="about" className="py-24 bg-[#0a0a0a]" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        >
          {/* Section Title */}
          <motion.h2
            variants={itemVariants}
            className="text-5xl md:text-6xl font-bold text-white text-center mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {aboutData.title}
          </motion.h2>

          {/* Description */}
          <motion.p
            variants={itemVariants}
            className="text-lg md:text-xl text-white/70 text-center max-w-4xl mx-auto mb-12"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            {aboutData.description}
          </motion.p>

          {/* Mission Statement */}
          <motion.div
            variants={itemVariants}
            className="bg-[#1a1a1a] p-8 md:p-12 mb-16 border-l-4 border-[#e8d5c4]"
          >
            <p
              className="text-xl md:text-2xl text-white/90 italic leading-relaxed"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {aboutData.mission}
            </p>
          </motion.div>

          {/* Values Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {aboutData.values.map((value, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                whileHover={{ y: -10, transition: { duration: 0.3 } }}
                className="bg-[#121212] p-8 group hover:bg-[#1a1a1a] transition-all"
              >
                <div className="h-1 w-16 bg-[#e8d5c4] mb-6 group-hover:w-full transition-all duration-500"></div>
                <h3
                  className="text-2xl font-bold text-white mb-4"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {value.title}
                </h3>
                <p
                  className="text-white/70"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {value.description}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
